module.exports = __webpack_public_path__ + "assets/img/thumb-ImuPro-1-Video.231670b6.webp";